import { render, staticRenderFns } from "./course_details.vue?vue&type=template&id=3d683b10&scoped=true&"
import script from "./course_details.vue?vue&type=script&lang=js&"
export * from "./course_details.vue?vue&type=script&lang=js&"
import style0 from "./course_details.vue?vue&type=style&index=0&id=3d683b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d683b10",
  null
  
)

export default component.exports